import * as next from '../../../types/next'
import type { AvailabilityCheckControlOptions } from '../../../utils'
import { CONTROL_NAME } from '../../../utils'
import type { UpBlockHandler } from '../types'

import { upCommonSettings } from './common'

export const up: UpBlockHandler<next.AvailabilityCheckBlock> = (uischema) => {
  if (uischema.type !== CONTROL_NAME.AVAILABILITY_CHECK) {
    throw new Error('Expected a valid AvailabilityCheck control')
  }

  return {
    id: uischema.id,
    type: next.BLOCK_TYPE.AVAILABILITY_CHECK,
    settings: {
      ...upCommonSettings(uischema),
      ...(uischema.options as AvailabilityCheckControlOptions)
    },
    // This block shouldn't contain any references to other objects,
    // but instead be referenced by them (i.e. logics)
    references: {}
  }
}
